import { TeamRole } from 'api/models'
import { TFunction } from 'react-i18next'

export const getTeamRoleName = (
  role?: TeamRole | null,
  t?: TFunction<'translation', undefined>,
) => {
  if (t) {
    switch (role) {
      case TeamRole.ADMIN:
        return t('user.teamRole.admin')
      case TeamRole.CONTRIBUTOR:
        return t('user.teamRole.contributor')
      case TeamRole.NONE:
        return t('user.none')
      default:
        return ''
    }
  }
  return ''
}
